export const filterTypes = {
  TEXT: 'text',
  NUMERIC_INTEGER: 'numericInteger',
  INT_NUMBER: 'int_number', // same as numericInteger, just uses different input field
  DECIMAL_NUMBER: 'decimal_number',
  DATE: 'date',
  LIST: 'list',
  PERIOD_LIST: 'period_list',
  RADIO_COMBO: 'radioCombo',
  IMAGE_COMBO: 'imageCombo',
  AUTOCOMPLETE: 'autocomplete',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  VIRTUAL: 'virtual',
  RANGE: 'range',
  CHECKBOXLIST_VERTICAL: 'checkboxlist_vertical',
}
